__turbopack_context__.v({
  "active": "DesktopDropdownMenu-module-scss-module__PLPpja__active",
  "caretIcon": "DesktopDropdownMenu-module-scss-module__PLPpja__caretIcon",
  "dropdown": "DesktopDropdownMenu-module-scss-module__PLPpja__dropdown",
  "dropdownArrowWrapper": "DesktopDropdownMenu-module-scss-module__PLPpja__dropdownArrowWrapper",
  "dropdownContent": "DesktopDropdownMenu-module-scss-module__PLPpja__dropdownContent",
  "focused": "DesktopDropdownMenu-module-scss-module__PLPpja__focused",
  "item": "DesktopDropdownMenu-module-scss-module__PLPpja__item",
  "menu": "DesktopDropdownMenu-module-scss-module__PLPpja__menu",
  "menuWrapper": "DesktopDropdownMenu-module-scss-module__PLPpja__menuWrapper",
});
